import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "subheader-block ml-auto demo" }
const _hoisted_4 = { class: "btn-group" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  class: "dropdown-menu",
  style: {}
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "btn-group" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  class: "dropdown-menu",
  style: {}
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-xl-12" }
const _hoisted_21 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_22 = { class: "panel-container show" }
const _hoisted_23 = { class: "panel-content border-faded border-left-0 border-right-0 border-top-0 text-muted d-flex" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-auto ml-auto" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-sm-6" }
const _hoisted_28 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_29 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_30 = { class: "panel-content contents" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = {
  class: "col-xl-4",
  id: "col1"
}
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-md-10 contCnt input-daterange input-group" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-md-10 contCnt" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-md-10 contCnt" }
const _hoisted_42 = {
  class: "row",
  style: {"margin-bottom":"0px"}
}
const _hoisted_43 = { class: "col-md-12" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col-md-10 contCnt" }
const _hoisted_46 = {
  class: "row",
  style: {"margin-bottom":"0px"}
}
const _hoisted_47 = { class: "col-md-12" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-md-10 contCnt" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-md-10 contCnt" }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-md-10 contCnt" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-md-10 contCnt" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col-md-10" }
const _hoisted_58 = {
  class: "col-xl-8",
  id: "col2"
}
const _hoisted_59 = { class: "row" }
const _hoisted_60 = {
  class: "col-xl-7",
  id: "col2-1"
}
const _hoisted_61 = { class: "row" }
const _hoisted_62 = { class: "col-md-10 contCnt" }
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "col-md-10 contCnt input-daterange input-group" }
const _hoisted_65 = {
  class: "input-daterange input-group",
  id: "datepicker-5"
}
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col-md-10 contCnt input-daterange input-group" }
const _hoisted_68 = {
  class: "input-daterange input-group",
  id: "datepicker-5"
}
const _hoisted_69 = { class: "row" }
const _hoisted_70 = { class: "col-md-10 contCnt" }
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "col-md-10 contCnt" }
const _hoisted_73 = {
  class: "col-xl-5",
  id: "col2-2"
}
const _hoisted_74 = { class: "row" }
const _hoisted_75 = { class: "col-md-12 contCnt" }
const _hoisted_76 = { class: "input-group" }
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col-md-12 contCnt" }
const _hoisted_79 = {
  id: "file_result",
  style: {"overflow-y":"scroll","overflow-x":"hidden","margin":"0px","border":"1px solid #e5e5e5","height":"105px"}
}
const _hoisted_80 = { class: "fileContName" }
const _hoisted_81 = { class: "fileContDl" }
const _hoisted_82 = ["onClick"]
const _hoisted_83 = { class: "fileContDel" }
const _hoisted_84 = ["onClick"]
const _hoisted_85 = { class: "row" }
const _hoisted_86 = { class: "col-md-12 contCnt" }
const _hoisted_87 = { class: "card-group" }
const _hoisted_88 = { class: "card" }
const _hoisted_89 = { class: "card-body ankenCardBody" }
const _hoisted_90 = { class: "card-text cardRow" }
const _hoisted_91 = { class: "profitTableInnerRow profitTablePrice" }
const _hoisted_92 = { class: "card-text cardRow" }
const _hoisted_93 = { class: "profitTableInnerRow profitTablePrice" }
const _hoisted_94 = { class: "card-text cardRow" }
const _hoisted_95 = { class: "profitTableInnerRow profitTablePrice" }
const _hoisted_96 = { class: "card-text cardRow sumRow" }
const _hoisted_97 = { class: "profitTableInnerRow profitTablePrice" }
const _hoisted_98 = { class: "card" }
const _hoisted_99 = { class: "card-body ankenCardBody" }
const _hoisted_100 = { class: "card-text cardRow" }
const _hoisted_101 = { class: "profitTableInnerRow profitTablePrice" }
const _hoisted_102 = { class: "card-text cardRow" }
const _hoisted_103 = { class: "profitTableInnerRow profitTablePrice" }
const _hoisted_104 = { class: "card-text cardRow" }
const _hoisted_105 = { class: "profitTableInnerRow profitTablePrice" }
const _hoisted_106 = { class: "card-text cardRow sumRow" }
const _hoisted_107 = { class: "profitTableInnerRow profitTablePrice" }
const _hoisted_108 = { class: "card" }
const _hoisted_109 = { class: "card-body ankenCardBody" }
const _hoisted_110 = { class: "card-text cardRow" }
const _hoisted_111 = { class: "profitTableInnerRow profitTablePrice" }
const _hoisted_112 = { class: "card-text cardRow" }
const _hoisted_113 = { class: "profitTableInnerRow profitTablePrice" }
const _hoisted_114 = { class: "card-text cardRow" }
const _hoisted_115 = { class: "profitTableInnerRow profitTablePrice" }
const _hoisted_116 = { class: "card-text cardRow sumRow" }
const _hoisted_117 = { class: "profitTableInnerRow profitTablePrice" }
const _hoisted_118 = { class: "card" }
const _hoisted_119 = { class: "card-body ankenCardBody" }
const _hoisted_120 = { class: "card-text cardRow" }
const _hoisted_121 = { class: "profitTableInnerRow profitTablePrice" }
const _hoisted_122 = { class: "card-text cardRow" }
const _hoisted_123 = { class: "profitTableInnerRow profitTablePrice" }
const _hoisted_124 = { class: "card-text cardRow" }
const _hoisted_125 = { class: "profitTableInnerRow profitTablePrice" }
const _hoisted_126 = { class: "card-text cardRow sumRow" }
const _hoisted_127 = { class: "profitTableInnerRow profitTablePrice" }
const _hoisted_128 = { class: "row" }
const _hoisted_129 = { class: "col-xl-12" }
const _hoisted_130 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_131 = { class: "panel-container show" }
const _hoisted_132 = { class: "panel-content contents" }
const _hoisted_133 = { class: "text-success fw-500" }
const _hoisted_134 = { class: "modal-footer" }
const _hoisted_135 = { class: "modal-footer" }
const _hoisted_136 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Mt_dtp = _resolveComponent("Mt_dtp")!
  const _component_Or_tableJyutu = _resolveComponent("Or_tableJyutu")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[53] || (_cache[53] = _createElementVNode("div", { class: "subheader col-6" }, [
        _createElementVNode("h1", { class: "subheader-title" }, "案件情報入力")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isEditMode)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary dropdown-toggle dropdown-toggle-split waves-effect waves-themed",
                disabled: _ctx.btnDisable,
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
              }, _cache[48] || (_cache[48] = [
                _createElementVNode("span", { class: "fal fa-copy mr-1" }, null, -1),
                _createTextVNode("案件コピー   "),
                _createElementVNode("span", { class: "sr-only" }, "Toggle Dropdown", -1)
              ]), 8, _hoisted_5))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", {
              class: "dropdown-item",
              href: "javascript:void(0);",
              disabled: _ctx.btnDisable,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cpyProjectNow()))
            }, "今期(" + _toDisplayString(_ctx.nowBusinessYear) + "期)", 9, _hoisted_7),
            _createElementVNode("a", {
              class: "dropdown-item",
              href: "javascript:void(0);",
              disabled: _ctx.btnDisable,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cpyProjectNext()))
            }, "来期(" + _toDisplayString(_ctx.nowBusinessYear + 1) + "期)", 9, _hoisted_8),
            _createElementVNode("a", {
              class: "dropdown-item",
              href: "javascript:void(0);",
              disabled: _ctx.btnDisable,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cpyProjectBefore && _ctx.cpyProjectBefore(...args)))
            }, "前期(" + _toDisplayString(_ctx.nowBusinessYear - 1) + "期)", 9, _hoisted_9)
          ])
        ]),
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-primary waves-effect waves-themed",
              disabled: _ctx.btnDisable,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.creClaim(false, $event)))
            }, _cache[49] || (_cache[49] = [
              _createElementVNode("span", { class: "fal fa-download mr-1" }, null, -1),
              _createTextVNode("請求書作成 ")
            ]), 8, _hoisted_10))
          : _createCommentVNode("", true),
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn-primary waves-effect waves-themed",
              disabled: _ctx.btnDisable,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.upd(false, false)))
            }, _cache[50] || (_cache[50] = [
              _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
              _createTextVNode("登録 ")
            ]), 8, _hoisted_11))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          (_ctx.isEditMode)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary dropdown-toggle dropdown-toggle-split waves-effect waves-themed",
                disabled: _ctx.btnDisable,
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
              }, _cache[51] || (_cache[51] = [
                _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
                _createTextVNode("新規   "),
                _createElementVNode("span", { class: "sr-only" }, "Toggle Dropdown", -1)
              ]), 8, _hoisted_13))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("a", {
              class: "dropdown-item",
              href: "javascript:void(0);",
              disabled: _ctx.btnDisable,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addNow()))
            }, "今期(" + _toDisplayString(_ctx.nowBusinessYear) + "期)", 9, _hoisted_15),
            _createElementVNode("a", {
              class: "dropdown-item",
              href: "javascript:void(0);",
              disabled: _ctx.btnDisable,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addNext()))
            }, "来期(" + _toDisplayString(_ctx.nowBusinessYear + 1) + "期)", 9, _hoisted_16),
            _createElementVNode("a", {
              class: "dropdown-item",
              href: "javascript:void(0);",
              disabled: _ctx.btnDisable,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addBefore()))
            }, "前期(" + _toDisplayString(_ctx.nowBusinessYear - 1) + "期)", 9, _hoisted_17)
          ])
        ]),
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "btn btn-danger waves-effect waves-themed",
              disabled: _ctx.btnDisable,
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.delConf()))
            }, _cache[52] || (_cache[52] = [
              _createElementVNode("span", { class: "fal fa-times mr-1" }, null, -1),
              _createTextVNode("削除 ")
            ]), 8, _hoisted_18))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _cache[98] || (_cache[98] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, "基本情報"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_22, [
            _cache[97] || (_cache[97] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _cache[56] || (_cache[56] = _createElementVNode("span", { style: {"margin-right":"15px"} }, "請求方法", -1)),
                      _createElementVNode("div", _hoisted_28, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          class: "custom-control-input",
                          id: "radioBulk",
                          name: "radioBillingMethod",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.delegate.c_project_billing_type) = $event)),
                          value: "1"
                        }, null, 512), [
                          [_vModelRadio, _ctx.delegate.c_project_billing_type]
                        ]),
                        _cache[54] || (_cache[54] = _createElementVNode("label", {
                          class: "custom-control-label",
                          for: "radioBulk"
                        }, "一括", -1))
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          class: "custom-control-input",
                          id: "radioSplit",
                          name: "radioBillingMethod",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.delegate.c_project_billing_type) = $event)),
                          value: "2"
                        }, null, 512), [
                          [_vModelRadio, _ctx.delegate.c_project_billing_type]
                        ]),
                        _cache[55] || (_cache[55] = _createElementVNode("label", {
                          class: "custom-control-label",
                          for: "radioSplit"
                        }, "分割", -1))
                      ])
                    ]),
                    _cache[57] || (_cache[57] = _createElementVNode("div", { class: "col-sm-6" }, [
                      _createElementVNode("div", {
                        style: {"width":"400px"},
                        id: "headSpacer"
                      })
                    ], -1))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _cache[58] || (_cache[58] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "案件番号", -1)),
                    _createElementVNode("div", _hoisted_34, [
                      _withDirectives(_createElementVNode("input", {
                        id: "jyutyuNumber",
                        type: "text",
                        class: "form-control form-control-sm",
                        readonly: "true",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.jyutyuNumber) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.jyutyuNumber]
                      ]),
                      _createElementVNode("input", {
                        type: "button",
                        class: "btn-primary form-control form-control-sm",
                        value: "検索",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$router.push('/projectSearch'))),
                        disabled: _ctx.btnDisable
                      }, null, 8, _hoisted_35),
                      _createElementVNode("input", {
                        type: "button",
                        class: "btn-primary form-control form-control-sm",
                        value: "<<",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.goPrev())),
                        disabled: _ctx.btnDisable
                      }, null, 8, _hoisted_36),
                      _createElementVNode("input", {
                        type: "button",
                        class: "btn-primary form-control form-control-sm",
                        value: ">>",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.goNext())),
                        disabled: _ctx.btnDisable
                      }, null, 8, _hoisted_37)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _cache[59] || (_cache[59] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "案件名", -1)),
                    _createElementVNode("div", _hoisted_39, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "txtAnkenNm",
                        id: "txtAnkenNm",
                        maxlength: "200",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.delegate.c_project_name) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.delegate.c_project_name]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _cache[60] || (_cache[60] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "売上先", -1)),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_vSelect, {
                            options: _ctx.delegate4list.items4Client,
                            modelValue: _ctx.delegate.c_client_id,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.delegate.c_client_id) = $event)),
                            label: "c_client_name",
                            reduce: (label) => label.c_client_id
                          }, null, 8, ["options", "modelValue", "reduce"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _cache[61] || (_cache[61] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "仕入先", -1)),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createVNode(_component_vSelect, {
                            options: _ctx.delegate4list.items4Suplier,
                            modelValue: _ctx.delegate.c_supplier_id,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.delegate.c_supplier_id) = $event)),
                            label: "c_supplier_name",
                            reduce: (label) => label.c_supplier_id
                          }, null, 8, ["options", "modelValue", "reduce"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _cache[62] || (_cache[62] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "広告主", -1)),
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_vSelect, {
                        options: _ctx.delegate4list.items4Sponsor,
                        modelValue: _ctx.delegate.c_sponsor_id,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.delegate.c_sponsor_id) = $event)),
                        label: "c_sponsor_name",
                        reduce: (label) => label.c_sponsor_id
                      }, null, 8, ["options", "modelValue", "reduce"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _cache[63] || (_cache[63] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "拠点", -1)),
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_vSelect, {
                        options: _ctx.delegate4list.items4Branch,
                        modelValue: _ctx.delegate.c_branch_id,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.delegate.c_branch_id) = $event)),
                        label: "c_branch_name",
                        reduce: (label) => label.c_branch_id
                      }, null, 8, ["options", "modelValue", "reduce"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _cache[64] || (_cache[64] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "営業担当", -1)),
                    _createElementVNode("div", _hoisted_53, [
                      _createVNode(_component_vSelect, {
                        options: _ctx.getOpStaffs(1),
                        modelValue: _ctx.delegate.c_staff_id4sales,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.delegate.c_staff_id4sales) = $event)),
                        label: "c_staff_name",
                        reduce: (label) => label.c_staff_id
                      }, null, 8, ["options", "modelValue", "reduce"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _cache[65] || (_cache[65] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "仕入担当", -1)),
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_component_vSelect, {
                        options: _ctx.getOpStaffs(2),
                        modelValue: _ctx.delegate.c_staff_id4supply,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.delegate.c_staff_id4supply) = $event)),
                        label: "c_staff_name",
                        reduce: (label) => label.c_staff_id
                      }, null, 8, ["options", "modelValue", "reduce"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _cache[66] || (_cache[66] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "備考", -1)),
                    _createElementVNode("div", _hoisted_57, [
                      _withDirectives(_createElementVNode("textarea", {
                        name: "txtBiko",
                        id: "txtBiko",
                        class: "example2 form-control",
                        style: {"height":"37px"},
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.remarks) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.remarks]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _cache[67] || (_cache[67] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "案件種類", -1)),
                        _createElementVNode("div", _hoisted_62, [
                          _createVNode(_component_vSelect, {
                            options: _ctx.opProjectType,
                            modelValue: _ctx.delegate.c_project_type,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.delegate.c_project_type) = $event)),
                            label: "label",
                            reduce: (label) => label.code
                          }, null, 8, ["options", "modelValue", "reduce"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _cache[69] || (_cache[69] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "販売契約期間", -1)),
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _createVNode(_component_Mt_dtp, {
                              contdate: _ctx.delegate.cnvSalesdateStart,
                              "onUpdate:contdate": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.delegate.cnvSalesdateStart) = $event)),
                              holidays: _ctx.delegate4list,
                              "onUpdate:holidays": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.delegate4list) = $event)),
                              class: "radius-1"
                            }, null, 8, ["contdate", "holidays"]),
                            _cache[68] || (_cache[68] = _createElementVNode("div", { class: "input-group-append input-group-prepend input-group-joinner" }, [
                              _createElementVNode("span", { class: "input-group-text fs-xl" }, "－")
                            ], -1)),
                            _createVNode(_component_Mt_dtp, {
                              contdate: _ctx.delegate.cnvSalesdateEnd,
                              "onUpdate:contdate": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.delegate.cnvSalesdateEnd) = $event)),
                              holidays: _ctx.delegate4list,
                              "onUpdate:holidays": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.delegate4list) = $event)),
                              class: "radius-2"
                            }, null, 8, ["contdate", "holidays"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _cache[71] || (_cache[71] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "仕入契約期間", -1)),
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("div", _hoisted_68, [
                            _createVNode(_component_Mt_dtp, {
                              contdate: _ctx.delegate.cnvSupplydateStart,
                              "onUpdate:contdate": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.delegate.cnvSupplydateStart) = $event)),
                              holidays: _ctx.delegate4list,
                              "onUpdate:holidays": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.delegate4list) = $event)),
                              class: "radius-1"
                            }, null, 8, ["contdate", "holidays"]),
                            _cache[70] || (_cache[70] = _createElementVNode("div", { class: "input-group-append input-group-prepend input-group-joinner" }, [
                              _createElementVNode("span", { class: "input-group-text fs-xl" }, "－")
                            ], -1)),
                            _createVNode(_component_Mt_dtp, {
                              contdate: _ctx.delegate.cnvSupplydateEnd,
                              "onUpdate:contdate": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.delegate.cnvSupplydateEnd) = $event)),
                              holidays: _ctx.delegate4list,
                              "onUpdate:holidays": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.delegate4list) = $event)),
                              class: "radius-2"
                            }, null, 8, ["contdate", "holidays"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _cache[72] || (_cache[72] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "販売アラート", -1)),
                        _createElementVNode("div", _hoisted_70, [
                          _createVNode(_component_vSelect, {
                            options: _ctx.opAlertContract,
                            modelValue: _ctx.delegate.c_project_sales_alert,
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.delegate.c_project_sales_alert) = $event)),
                            label: "label",
                            reduce: (label) => label.code
                          }, null, 8, ["options", "modelValue", "reduce"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _cache[73] || (_cache[73] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "仕入アラート", -1)),
                        _createElementVNode("div", _hoisted_72, [
                          _createVNode(_component_vSelect, {
                            options: _ctx.opAlertContract,
                            modelValue: _ctx.delegate.c_project_supply_alert,
                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.delegate.c_project_supply_alert) = $event)),
                            label: "label",
                            reduce: (label) => label.code
                          }, null, 8, ["options", "modelValue", "reduce"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _cache[74] || (_cache[74] = _createElementVNode("div", { class: "col-md-12 contTitle" }, "契約書", -1)),
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("input", {
                              id: "file-upload",
                              type: "file",
                              ref: "uploadFile",
                              onChange: _cache[34] || (_cache[34] = ($event: any) => (_ctx.postFile())),
                              style: {"display":"none"}
                            }, null, 544),
                            _createElementVNode("button", {
                              class: "btn btn-primary waves-effect waves-themed",
                              type: "button",
                              style: {"margin-right":"8px","height":"30px","line-height":"15px"},
                              id: "inputGroupFileAddon04",
                              onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.clickFileUp()))
                            }, " アップロード ")
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_77, [
                        _cache[76] || (_cache[76] = _createElementVNode("div", { class: "col-md-12 contTitle" }, "ファイルリスト", -1)),
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("div", _hoisted_79, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delegate.files, (file) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "fileRow",
                                key: file.c_file_id!
                              }, [
                                _createElementVNode("div", _hoisted_80, _toDisplayString(file.c_file_name), 1),
                                _createElementVNode("div", _hoisted_81, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-xs btn-primary waves-effect waves-themed",
                                    style: {"width":"100%"},
                                    onClick: ($event: any) => (_ctx.dlFile(file))
                                  }, " Download ", 8, _hoisted_82)
                                ]),
                                _createElementVNode("div", _hoisted_83, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-xs btn-danger waves-effect waves-themed",
                                    style: {"width":"100%"},
                                    onClick: ($event: any) => (_ctx.delFileConf(file))
                                  }, " 削除 ", 8, _hoisted_84)
                                ]),
                                _cache[75] || (_cache[75] = _createElementVNode("p", { style: {"clear":"both"} }, null, -1))
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                          _cache[81] || (_cache[81] = _createElementVNode("div", {
                            class: "w-100 bg-fusion-50 rounded-top border-top-right-radius-0",
                            style: {"padding":"5px","text-align":"center"}
                          }, " 売上 ", -1)),
                          _createElementVNode("div", _hoisted_89, [
                            _createElementVNode("p", _hoisted_90, [
                              _cache[77] || (_cache[77] = _createElementVNode("span", null, "媒体料", -1)),
                              _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.profitDatas.sumSales4medium), 1)
                            ]),
                            _createElementVNode("p", _hoisted_92, [
                              _cache[78] || (_cache[78] = _createElementVNode("span", null, "施工費", -1)),
                              _createElementVNode("span", _hoisted_93, _toDisplayString(_ctx.profitDatas.sumSales4construction), 1)
                            ]),
                            _createElementVNode("p", _hoisted_94, [
                              _cache[79] || (_cache[79] = _createElementVNode("span", null, "非課税", -1)),
                              _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.profitDatas.sumSales4notax), 1)
                            ]),
                            _createElementVNode("p", _hoisted_96, [
                              _cache[80] || (_cache[80] = _createElementVNode("span", null, "売上合計", -1)),
                              _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.profitDatas.sumSalesTotal), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_98, [
                          _cache[86] || (_cache[86] = _createElementVNode("div", {
                            class: "w-100 bg-fusion-50",
                            style: {"padding":"5px","text-align":"center"}
                          }, " 仕入 ", -1)),
                          _createElementVNode("div", _hoisted_99, [
                            _createElementVNode("p", _hoisted_100, [
                              _cache[82] || (_cache[82] = _createElementVNode("span", null, "媒体料", -1)),
                              _createElementVNode("span", _hoisted_101, _toDisplayString(_ctx.profitDatas.sumSupplys4medium), 1)
                            ]),
                            _createElementVNode("p", _hoisted_102, [
                              _cache[83] || (_cache[83] = _createElementVNode("span", null, "施工費", -1)),
                              _createElementVNode("span", _hoisted_103, _toDisplayString(_ctx.profitDatas.sumSupplys4construction), 1)
                            ]),
                            _createElementVNode("p", _hoisted_104, [
                              _cache[84] || (_cache[84] = _createElementVNode("span", null, "非課税", -1)),
                              _createElementVNode("span", _hoisted_105, _toDisplayString(_ctx.profitDatas.sumSupplys4notax), 1)
                            ]),
                            _createElementVNode("p", _hoisted_106, [
                              _cache[85] || (_cache[85] = _createElementVNode("span", null, "仕入合計", -1)),
                              _createElementVNode("span", _hoisted_107, _toDisplayString(_ctx.profitDatas.sumSupplysTotal), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_108, [
                          _cache[91] || (_cache[91] = _createElementVNode("div", {
                            class: "w-100 bg-fusion-50",
                            style: {"padding":"5px","text-align":"center"}
                          }, " 利益 ", -1)),
                          _createElementVNode("div", _hoisted_109, [
                            _createElementVNode("p", _hoisted_110, [
                              _cache[87] || (_cache[87] = _createElementVNode("span", null, "媒体料", -1)),
                              _createElementVNode("span", _hoisted_111, _toDisplayString(_ctx.profitDatas.profit4medium), 1)
                            ]),
                            _createElementVNode("p", _hoisted_112, [
                              _cache[88] || (_cache[88] = _createElementVNode("span", null, "施工費", -1)),
                              _createElementVNode("span", _hoisted_113, _toDisplayString(_ctx.profitDatas.profit4construction), 1)
                            ]),
                            _createElementVNode("p", _hoisted_114, [
                              _cache[89] || (_cache[89] = _createElementVNode("span", null, "非課税", -1)),
                              _createElementVNode("span", _hoisted_115, _toDisplayString(_ctx.profitDatas.profit4notax), 1)
                            ]),
                            _createElementVNode("p", _hoisted_116, [
                              _cache[90] || (_cache[90] = _createElementVNode("span", null, "利益合計", -1)),
                              _createElementVNode("span", _hoisted_117, _toDisplayString(_ctx.profitDatas.profitTotal), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_118, [
                          _cache[96] || (_cache[96] = _createElementVNode("div", {
                            class: "w-100 bg-fusion-50 rounded-top border-top-left-radius-0",
                            style: {"padding":"5px","text-align":"center"}
                          }, " 利益率 ", -1)),
                          _createElementVNode("div", _hoisted_119, [
                            _createElementVNode("p", _hoisted_120, [
                              _cache[92] || (_cache[92] = _createElementVNode("span", null, "媒体料", -1)),
                              _createElementVNode("span", _hoisted_121, _toDisplayString(_ctx.profitDatas.profitRatio4medium), 1)
                            ]),
                            _createElementVNode("p", _hoisted_122, [
                              _cache[93] || (_cache[93] = _createElementVNode("span", null, "施工費", -1)),
                              _createElementVNode("span", _hoisted_123, _toDisplayString(_ctx.profitDatas.profitRatio4construction), 1)
                            ]),
                            _createElementVNode("p", _hoisted_124, [
                              _cache[94] || (_cache[94] = _createElementVNode("span", null, "非課税", -1)),
                              _createElementVNode("span", _hoisted_125, _toDisplayString(_ctx.profitDatas.profitRatio4notax), 1)
                            ]),
                            _createElementVNode("p", _hoisted_126, [
                              _cache[95] || (_cache[95] = _createElementVNode("span", null, "利益率合計", -1)),
                              _createElementVNode("span", _hoisted_127, _toDisplayString(_ctx.profitDatas.profitRatioAvr), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_128, [
      _createElementVNode("div", _hoisted_129, [
        _createElementVNode("div", _hoisted_130, [
          _cache[100] || (_cache[100] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, "明細"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_131, [
            _cache[99] || (_cache[99] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_132, [
              _createVNode(_component_Or_tableJyutu, {
                ref: "or_tableJyutu",
                projectData: _ctx.delegate,
                "onUpdate:projectData": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.delegate) = $event)),
                profitData: _ctx.profitDatas,
                "onUpdate:profitData": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.profitDatas) = $event)),
                mastersData: _ctx.delegate4list,
                "onUpdate:mastersData": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.delegate4list) = $event)),
                doReget: _ctx.doReget,
                "onUpdate:doReget": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.doReget) = $event)),
                doPut: _ctx.doPut,
                "onUpdate:doPut": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.doPut) = $event))
              }, null, 8, ["projectData", "profitData", "mastersData", "doReget", "doPut"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_alert, {
      ref: "Mo_modal_success",
      onModalclosed: _cache[41] || (_cache[41] = ($event: any) => (_ctx.get()))
    }, {
      title: _withCtx(() => [
        _cache[101] || (_cache[101] = _createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1)),
        _createElementVNode("span", _hoisted_133, _toDisplayString(_ctx.message4ModalSuccess), 1)
      ]),
      body: _withCtx(() => _cache[102] || (_cache[102] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => _cache[103] || (_cache[103] = [
        _createElementVNode("div", { class: "modal-footer" }, [
          _createElementVNode("br")
        ], -1)
      ])),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_deleteConf" }, {
      title: _withCtx(() => [
        _cache[104] || (_cache[104] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalDelConf), 1)
      ]),
      body: _withCtx(() => _cache[105] || (_cache[105] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_134, [
          _createElementVNode("button", {
            onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.del())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.closeModal4deleteConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_deleteFileConf" }, {
      title: _withCtx(() => [
        _cache[106] || (_cache[106] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalDelFileConf), 1)
      ]),
      body: _withCtx(() => _cache[107] || (_cache[107] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_135, [
          _createElementVNode("button", {
            onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.delFile())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.closeModal4deleteFileConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _cache[108] || (_cache[108] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => _cache[109] || (_cache[109] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_136, [
          _createElementVNode("button", {
            onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, {
      ref: "Mo_modal_invoiceCreate",
      onModalclosed: _cache[47] || (_cache[47] = ($event: any) => (_ctx.creClaim(true, $event)))
    }, {
      title: _withCtx(() => _cache[110] || (_cache[110] = [
        _createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1),
        _createElementVNode("span", { class: "text-success fw-500" }, [
          _createTextVNode(" 明細や備考などは請求書データを初めて作成される時のみ自動反映されます。"),
          _createElementVNode("br"),
          _createTextVNode(" 請求書データが作成済の場合は手動で更新を行ってください。 ")
        ], -1)
      ])),
      body: _withCtx(() => _cache[111] || (_cache[111] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => _cache[112] || (_cache[112] = [
        _createElementVNode("div", { class: "modal-footer" }, [
          _createElementVNode("br")
        ], -1)
      ])),
      _: 1
    }, 512)
  ]))
}